export default __webpack_public_path__ + "thirdCarouselItem.913981270c064ebd47465541e0f8fb99.png";